import { haptic } from '../../lib/native';
import { create } from 'zustand';

export const MIN_ZOOM = 0.15;
export const MAX_ZOOM = 2.5;
export const clampZoom = (k: number) => Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, k));

interface ViewState {
  x: number;
  y: number;
  k: number;
  selectedId: string | null;
  set: (v: Partial<Pick<ViewState, 'x' | 'y' | 'k'>>) => void;
  select: (id: string | null) => void;
  /** Zoom keeping the screen point (px, py) fixed. */
  zoomAt: (px: number, py: number, nextK: number) => void;
}

export const useView = create<ViewState>((set, get) => ({
  x: 0,
  y: 0,
  k: 1,
  selectedId: null,
  set: (v) => set(v),
  select: (id) => {
    if (id) haptic();
    set({ selectedId: id });
  },
  zoomAt: (px, py, nextK) => {
    const { x, y, k } = get();
    const kk = clampZoom(nextK);
    const wx = (px - x) / k;
    const wy = (py - y) / k;
    set({ k: kk, x: px - wx * kk, y: py - wy * kk });
  },
}));
